"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const navbar_style_1 = __importDefault(require("../navbar.style"));
const DefaultProfile = ({ fullname }) => {
    const getInitialCodeName = () => {
        const [first, second] = fullname.split(' ');
        let str = '';
        if (first)
            str += first[0];
        if (second)
            str += second[0];
        return str;
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: navbar_style_1.default.containerDefaultProfile }, { children: getInitialCodeName() })));
};
exports.default = DefaultProfile;
